import { apiClient } from '@/utils/axios';
import { ProductListItem } from "@/types/api/product";
import { SaleStatus } from '@/types/api/sale/sale-status.enum';

export interface Shop {
  id: string;
  code: string;
  link: string;
  createdAt: string;
  user: {
    id: string;
    name: string;
  };
  group: {
    id: string;
    name: string;
  };
  sale: {
    id: string;
    name: string;
    status: SaleStatus;
    cutoffAt: string;
    deliveryAt: string;
  };
  products: ProductListItem[];
}

export default {
  get: async (code: string) => {
    const response = await apiClient.get<Shop>(`/shops/${code}`);
    return response.data;
  },
};
